import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  // ─── 公开页面 ──────────────────────────────────────────────────────────
  { path: '/', name: 'Home', component: () => import('@/views/Home.vue') },
  { path: '/login', name: 'Login', component: () => import('@/views/auth/Login.vue'), meta: { guest: true } },
  { path: '/register', name: 'Register', component: () => import('@/views/auth/Register.vue'), meta: { guest: true } },
  { path: '/news', name: 'News', component: () => import('@/views/News.vue') },
  { path: '/news/:id', name: 'NewsDetail', component: () => import('@/views/NewsDetail.vue') },
  { path: '/custom', name: 'Custom', component: () => import('@/views/Custom.vue') },
  { path: '/search', name: 'Search', component: () => import('@/views/Search.vue') },
  { path: '/subscription', name: 'Subscription', component: () => import('@/views/Subscription.vue') },
  { path: '/knowledge', name: 'Knowledge', component: () => import('@/views/Knowledge.vue'), meta: { requiresAuth: true } },
  { path: '/knowledge/:id', name: 'KnowledgeDetail', component: () => import('@/views/KnowledgeDetail.vue'), meta: { requiresAuth: true } },
  { path: '/policy/:type', name: 'PolicyPage', component: () => import('@/views/PolicyPage.vue') },

  // ─── 付费数据模块（requiresAuth + requiresPaid） ────────────────────────
  {
    path: '/data',
    component: () => import('@/views/data/DataLayout.vue'),
    redirect: '/data/enterprise-finance',
    children: [
      {
        path: 'primary-market',
        name: 'PrimaryMarket',
        component: () => import('@/views/data/PrimaryMarket.vue'),
        meta: { title: '一级市场投融资', requiresAuth: true }
      },
      {
        path: 'enterprise-finance',
        name: 'EnterpriseFinance',
        component: () => import('@/views/data/EnterpriseFinance.vue'),
        meta: { title: '企业财务', requiresAuth: true }
      },
      {
        path: 'commodity',
        name: 'Commodity',
        component: () => import('@/views/data/Commodity.vue'),
        meta: { title: '大宗商品', requiresAuth: true }
      },
      {
        path: 'industry',
        name: 'IndustryData',
        component: () => import('@/views/data/IndustryData.vue'),
        meta: { title: '行业数据', requiresAuth: true }
      },
      {
        path: 'international-macro',
        name: 'InternationalMacro',
        component: () => import('@/views/data/InternationalMacro.vue'),
        meta: { title: '宏观数据', requiresAuth: true }
      },
      {
        path: 'domestic-macro',
        name: 'DomesticMacro',
        component: () => import('@/views/data/InternationalMacro.vue'),
        meta: { title: '国内宏观', requiresAuth: true }
      }
    ]
  },

  // ─── 研报（公开） ──────────────────────────────────────────────────────
  {
    path: '/research',
    name: 'Research',
    component: () => import('@/views/Research.vue')
  },
  {
    path: '/research/:id',
    name: 'ArticleDetail',
    component: () => import('@/views/ArticleDetail.vue')
  },

  // ─── 管理后台 ─────────────────────────────────────────────────────────
  {
    path: '/admin',
    component: () => import('@/views/admin/AdminLayout.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      { path: '', component: () => import('@/views/admin/Dashboard.vue') },
      { path: 'users', component: () => import('@/views/admin/UserManage.vue') },
      { path: 'modules', component: () => import('@/views/admin/ModuleManage.vue') },
      { path: 'contents', component: () => import('@/views/admin/ContentManage.vue') },
      { path: 'excel', component: () => import('@/views/admin/ExcelUpload.vue') },
      { path: 'industry', component: () => import('@/views/admin/IndustryManage.vue') },
      { path: 'orders', component: () => import('@/views/admin/OrderManage.vue') },
      { path: 'reports', component: () => import('@/views/admin/ReportManage.vue') },
      { path: 'knowledge', component: () => import('@/views/admin/KnowledgeManage.vue') },
      { path: 'prices', component: () => import('@/views/admin/PriceManage.vue') },
      { path: 'settings', component: () => import('@/views/admin/SettingsManage.vue') }
    ]
  },

  // ─── 404 ──────────────────────────────────────────────────────────────
  { path: '*', redirect: '/' }
]

const router = new VueRouter({ mode: 'hash', routes })

// ─── 全局路由守卫 ──────────────────────────────────────────────────────────
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn

  // 已登录用户不允许访问 guest 页面（login/register）
  if (to.meta.guest && isLoggedIn) return next('/')

  // 需要登录
  if (to.meta.requiresAuth && !isLoggedIn) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  // 需要管理员
  if (to.meta.requiresAdmin && isLoggedIn && !store.getters.isAdmin) {
    return next('/')
  }

  next()
})

export default router
